export default {"src":"/_next/static/media/eye_40.32617a48.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};